<script setup lang="ts">
import { useSessionStore } from '../stores/session.js';
const session = useSessionStore();
</script>

<template>
  <main class="login-shell">
    <section class="login-card">
      <div class="brand-mark">C</div>
      <p class="eyebrow">PRIVATE WEB TELEPHONY</p>
      <h1>Calls that stay yours.</h1>
      <p class="muted">
        Connect your own Voximplant account and call any permitted landline or mobile number
        directly from your browser.
      </p>
      <button class="primary wide" @click="session.login">Continue with Google</button>
      <p class="fine-print">
        Each account is isolated. Call details and provider credentials are never visible to
        platform administrators.
      </p>
    </section>
  </main>
</template>
